import BackButtonToolbar from "features/BackButtonToolbar";
import React, { useCallback, useEffect, useState } from "react";
import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect, useRefresh } from "react-admin";
import SaveForm from "../SaveForm";
import { graduationRequests } from "api/graduationApi";
import { useParams } from "react-router";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const EditInternshipPlans = () => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const { id } = useParams();

  const [defaultValues, setDefaultValues] = useState(null);

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(graduationRequests.getInternshipPlanForUpdate(id), null, "GET");
      setDefaultValues({ ...data, isWards: data.wards?.length > 0 });
    } catch (err) {
      notifyError(err);
    }
  }, [id, notifyError]);

  useEffect(() => {
    if (id) {
      fetchDefaultValues();
    }
  }, [id, fetchDefaultValues]);

  const handleSubmit = async data => {
    const { isWards, ...payload } = data;

    if (isWards || payload.isMonthlyInternship) {
      payload.disciplines = [];
    } else {
      payload.wards = [];
    }

    try {
      await dataProvider.customRequest(graduationRequests.updateInternshipPlan(id), payload, "PUT");
      notify("Успешно редактирахте стажатски план", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title title={`Редактиране на стажантски план`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={graduationRequests.getInternshipPlanForUpdate(id)}>
        {defaultValues && (
          <SimpleForm
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
          >
            <SaveForm />
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};

export default EditInternshipPlans;
